<cac-dialog-layout title="جزئیات {{data.itemName ?? ''}}" [hideControls]="true">
  <cac-form-builder [options]="data.formBuilder" class="mt-6 mb-8"></cac-form-builder>
</cac-dialog-layout>